module.exports = __webpack_public_path__ + "static/coin-rating-ce1627fc3d99227bac7814b976b183a0.png";